import { IdCard } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function PersonalDocumentsPage() {
  return (
    <PhaseStubPage
      title="Personal Documents"
      phase={6}
      modules={[
        'I-9 employment eligibility verification',
        'W-4 / state tax withholding forms',
        'Signed offer letter and employment agreements',
        'Emergency contacts and direct-deposit authorizations',
        'Secure document upload with HR review status',
      ]}
      icon={IdCard}
    />
  );
}
